import styled from 'styled-components/macro'
import { commonModalStyle, commonModalContentStyle } from 'src/global/helpers'

export const Modal = styled.div`
  ${commonModalStyle}
  width: 600px;
  background: ${props => props.theme.white};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;

  &.closed {
    pointer-events: none;
    opacity: 0;
  }

  .url {
    border-radius: 16px;
    padding: 4px 16px;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    margin-top: 8px;
    word-break: break-all;
    text-align: center;

    .slug {
      font-weight: 700;
      display: inline-block;
    }
  }

  .url svg {
    font-size: 14px;
    padding: 2px;
    margin-right: 4px;
    margin-bottom: -3px;
    color: ${props => props.theme.accent};
  }

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;

    button {
      flex-grow: 0;
    }
  }

  .table-number {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    background: ${props => props.theme.white};
    border-radius: 8px;
    flex-grow: 0;

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }

    .react-toggle-wrapper {
      margin-top: 0;
    }

    .icon {
      font-size: 16px;
      color: ${props => props.theme.accent};
    }

    span {
      text-align: center;
    }

    .input-wrapper {
      transition: all 0.3s cubic-bezier(0.25, 1, 0.32, 1);
      overflow: hidden;

      input {
        width: 155px;
        padding-right: 16px;
        margin-top: 0;
      }
    }

    .explanation {
      font-size: 13px;
      color: ${props => props.theme.mutedText};
      margin-left: 0;
      margin-right: 0;
      padding-top: 8px;
    }
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;
  width: 100%;
  background: ${props => props.theme.pageBackground};
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  padding: 16px;

  .centered-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .qr-code-wrapper {
    position: relative;
    margin-top: 16px;
    padding: 8px;
    border: 3px solid ${props => props.theme.accent};
    background: #fff;
    border-radius: 16px;

    .qr-code {
      width: 200px;
      display: block;
      border-radius: 6px;
      overflow: hidden;
      width: 120px;
    }
  }

  .qr-holders-section {
    margin-top: 16px;
    padding: 16px;
    border: 2px solid ${props => props.theme.accent};
    border-radius: 12px;
    background-color: ${props => props.theme.white};
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;

    img {
      width: 132px;
      border-radius: 8px;
      flex-shrink: 0;
      align-self: flex-start;
    }

    .holders-text {
      flex: 1;

      h3 {
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 8px 0;
        color: ${props => props.theme.normalText};
        text-align: left;
      }
    }

    @media (max-width: 768px) {
      img {
        width: 100px;
      }
    }
  }
`

export const ModalFooter = styled.div`
  border-top: 1px solid ${props => props.theme.border};
  padding: 12px;
  background: ${props => props.theme.pageBackground};
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    margin-top: 0;
  }
`
